import { BankMaster } from "./BindMdl";
import { mdlStatus } from "./CompAttachmentsMdl";
import { mdlCancellation_Reason_Master } from "./mdlCancellation_Reason_Master";
import { mdlTravelPolicyDetail } from "./mdlGetPolicyDetailsTravelRes";


export class mdlTravelCancellationInfoRes {
    public st: mdlStatus;
    public bankList: BankMaster[];
    public CancellationReasonList: mdlCancellation_Reason_Master[];
    public PolicyDetails: mdlTravelPolicyDetail;

    
    public IBANNo: string;
    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;
    public CancellationDate:string;
    public CancellationReason:number;
    public BankCode:string;
    public RequestNotes:string;
    public IDCopyImage:string;
    public IBANCopyImage:string;
    public RefundApplicable:number;
}

export class mdlTravelCancellationCalReq{
    // public RefundDays:number;
    // public Total:number;
    // public VATAmount:number;
    // public TotalPremiumPaid:number;
    // public RefundAmount:number;
    // public VATRefundAmount:number;
    // public UPRVAT:number;
    // public TotalRefundAmount:number;
    // public RefundApplicable:number;
    // public FinalRefundAmount:number;
    // public OverRiddenAmount:number;
    // public ApplicableMatrix:number;
    // public CoverageDays:number;


    // public IBANNo: string;
    // public IBAN1: string;
    // public IBAN2: string;
    // public IBAN3: string;
    // public IBAN4: string;
    // public IBAN5: string;
    // public IBAN6: string;
    // public CancellationDate:string;
    // public CancellationReason:number;
    // public BankCode:string;
    // public RequestNotes:string;
    // public IDCopyImage:string;
    // public IBANCopyImage:string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlTravelCancellationInfoRes.ts